import React, { useEffect } from "react";

const NotFound = (props) => {
    useEffect(()=>{
        window.location.href="https://misstomrsbox.com/not-found/";
    },[])
    return(
        <div></div>
    )
}
export default NotFound;